import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {call, select, takeLatest} from 'redux-saga/effects';

import {getDealSaga, getDealInvitesSaga} from 'api/deals';

import gql from 'graphql-tag';

const namespace = 'flows/deal/lead';

// Actions
const LOAD_DEAL_LEAD = defineAction('LOAD_DEAL_LEAD', namespace);
export const loadDealLead = createAction(LOAD_DEAL_LEAD.ACTION);

// Query
export const operation = 'DealLead';
export const query = gql`
  query ${operation}($dealId: ID!) {
    deal(id: $dealId) {
      id
      name
      self
      image
      status
      memo {
        link
      }
      model {
        link
      }
      metrics {
        allocation
        fees
        flatFees
        targetIRR
        targetCoC
      }
    }
  }
`;

// Load Deal Lead Saga
export function* loadDealLeadSaga({payload}) {
  // Load deal
  const deal = yield call(getDealSaga, {payload: payload.deal});

  if (deal.status === 'allocating') {
    // Load deal invites
    yield call(getDealInvitesSaga, {payload: payload.deal});
  }
}

export function* sagas() {
  yield takeLatest(LOAD_DEAL_LEAD.ACTION, loadDealLeadSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/deal/leadmanage/index.js